import { render, staticRenderFns } from "./MomentumConservationProViz.vue?vue&type=template&id=02dc5e12&scoped=true"
import script from "./MomentumConservationProViz.vue?vue&type=script&lang=js"
export * from "./MomentumConservationProViz.vue?vue&type=script&lang=js"
import style0 from "./MomentumConservationProViz.vue?vue&type=style&index=0&id=02dc5e12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc5e12",
  null
  
)

export default component.exports